import styled from 'styled-components'
import * as All from '../BaseStyles'

import settingsIcon from '../../Icons/Normal/Dark/settings-icon.png'

import hoverSettingsIcon from '../../Icons/Hover/settings-icon.png'

export const SettingsButton = styled(All.IconButton)`
    width: 2.5rem;
    height: 2.5rem;
    background-image: url(${settingsIcon});
    &:hover{
        background-image: url(${hoverSettingsIcon});
    }
`